/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useUserProfile } from '../../../hooks/shared/user/useUserProfile';
import PATHS from '../../../routes/urls';
import RequisitionNotification from '../../staff/shared/layouts/sidebar/manager-and-executives/RequisitionNotification';
import AssetTeamSideBarItem from '../asset-team/sidebar/AssetTeamSideBarItem';
import { AES, enc } from 'crypto-js';
import { useUser } from '../../../hooks/shared/user/useUser';

const PartnershipSideBar = () => {
  const { getUserProfile, profile } = useUserProfile();
  const { user, profile: prof } = useUser();
  // console.log(profile);

  const role_id = Number(sessionStorage.getItem('roleId'));

  useEffect(() => {
    getUserProfile();
  }, []);

  return (
    <div className="s-layout__sidebar">
      <Link className="s-sidebar__trigger" to="#">
        <i className="fa fa-bars mr-3" />
      </Link>
      <nav className="s-sidebar__nav">
        <Link className="navbar-brand-logo" to="/business-development">
          <img src="https://res.cloudinary.com/tizeti/image/upload/v1542971047/Tizeti-Logo.png" alt="homepage" />
        </Link>
        <ul>
          <li>
            <span className="p-0 mt-3">
              <AssetTeamSideBarItem url="/partnership" name="Overview" />
            </span>
          </li>
          <li>
            <span className="p-0 mt-3">
              <AssetTeamSideBarItem url="/logs" name="Logs" />
            </span>
          </li>
          <li>
            <span className="p-0 mt-3">
              <AssetTeamSideBarItem url="/usage-history" name="Usage History" />
            </span>
          </li>
          <li>
            <span className="p-0 mt-3">
              <AssetTeamSideBarItem url="/signup-history" name="Signup History" />
            </span>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default PartnershipSideBar;
